<template>
	<div>
		<dialog-message-filter ref="DialogMessageFilter" />
		<dialog-edit-message ref="DialogEditMessage" />

		<v-data-table :headers="messageHeaders" :items="messageData" sort-by="calories" class="elevation-1">
			<template v-slot:top>
				<v-toolbar flat>
					<v-toolbar-title>{{ getTitleMessages }}</v-toolbar-title>
					<v-divider class="mx-4" inset vertical></v-divider>
					<v-spacer></v-spacer>

					<!--            Кнопка настройка фильтар-->
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn small class="mt-2" outlined fab color="primary" @click="clickMessagesFilter" v-bind="attrs" v-on="on">
								<v-icon>mdi-cog-outline</v-icon>
							</v-btn>
						</template>
						<span>Настройка фильтра</span>
					</v-tooltip>
				</v-toolbar>
			</template>

			<template v-slot:[`item.files`]="{ item }">
				<v-icon small class="mr-2" v-if="item.files.length > 0"> mdi-paperclip </v-icon>
			</template>

			<template v-slot:[`item.actions`]="{ item }">
				<v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
			</template>

			<template v-slot:no-data>
				<div v-html="$t('InboxPage.plugs.messages')" style="border: 2px dashed orange; border-radius: 10px" class="ma-2 pa-3 mt-5"></div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import DialogMessageFilter from "@/components/dialogs/DialogMessageFilter.vue"
import DialogEditMessage from "@/components/dialogs/DialogEditMessage.vue"

export default {
	name: "InboxPage",
	components: { DialogMessageFilter, DialogEditMessage },

	data() {
		return {
			messageHeaders: [
				{ text: "№ ", align: "start", sortable: true, value: "number" },
				{ text: "Дата", value: "date" },
				{ text: "Тема", value: "subject" },
				{ text: "Локация", value: "location" },
				{ text: "Статус", value: "status" },
				{ text: "Вложения", value: "files" },
				{ text: "Действия", value: "actions", sortable: false },
			],
		}
	},
	methods: {
		...mapActions("app", ["apiGetMessages", "apiSetMessageStatus"]),
		...mapMutations("app", ["setMessagesFilter"]),

		async clickMessagesFilter() {
			console.log("clickMessagesFilter")
			const result = await this.$refs.DialogMessageFilter.show({ ...this.getMessagesFilter })

			if (result.answer === "positive") {
				console.log(result)
				this.setMessagesFilter({
					date1: result.form.date1,
					date2: result.form.date2,
					locationsId: result.form.locations,
					statuses: result.form.statuses,
				})
				await this.apiGetMessages(this.getMessagesFilter)
				console.log("messages", this.getMessages)
			}
		},

		async editItem(item) {
			//switch (item.)
			// console.log('open', item)
			// this.apiSetMessageRead({GUID: item.GUID})
			const result = await this.$refs.DialogEditMessage.show({ ...item })

			console.log(result)
			if (result.answer === "positive") {
				await this.apiSetMessageStatus({ GUID: item.GUID, status: result.status, comment: "" })
			}
		},

		async editItemByGuid(guid) {
			const items = this.getMessages.filter((item) => item.GUID === guid)
			if (items.length === 1) {
				await this.editItem(items[0])
				this.$router.push({ name: "MyInboxPage" })
			}
		},
	},
	watch: {},
	computed: {
		...mapGetters("app", ["getMessages", "getMessagesFilter"]),

		messageData() {
			let arr = []
			if (!this.getMessages) return []
			console.log("this.getMessages", this.getMessages)
			this.getMessages.forEach((element) => {
				arr.push({
					GUID: element.GUID,
					number: element.number,
					date: element.date,
					messageType: element.messageType,
					status: element.status,
					readStatus: element.readStatus,
					location: element.location,
					subject: element.subject,
					comment: element.comment,
					files: element.files,
					linkTitle: element.linkTitle,
					linkURL: element.linkURL,
				})
			})
			return arr
		},

		getTitleMessages() {
			if (
				!this.getMessagesFilter.date1 &&
				!this.getMessagesFilter.date2 &&
				this.getMessagesFilter.locations &&
				this.getMessagesFilter.locations.length === 0 &&
				this.getMessagesFilter.statuses &&
				this.getMessagesFilter.statuses.length === 0
			) {
				return "Без фильтров"
			}
			let period =
				this.getMessagesFilter.date1 && this.getMessagesFilter.date1 !== "" && this.getMessagesFilter.date2 && this.getMessagesFilter.date2 !== ""
					? `${this.getMessagesFilter.date1} - ${this.getMessagesFilter.date2}`
					: "Не выбран"
			let locations =
				this.getMessagesFilter.locations && this.getMessagesFilter.locations.length > 0 ? this.getMessagesFilter.locations.join(", ") : "Не выбраны"
			let statuses = this.getMessagesFilter.statuses && this.getMessagesFilter.statuses.length > 0 ? this.getMessagesFilter.statuses.join(", ") : "Не выбраны"
			return `Период: ${period}, Локации: ${locations}, Статусы: ${statuses}`
		},
	},
	created() {
		// console.log('messages', this.getMessages)
	},
	mounted() {
		const url = new URL(window.location.href)
		const guid = url.searchParams.get("guid")
		if (guid !== null) {
			this.editItemByGuid(guid)
		}
	},
}
</script>
